import React, { Component } from 'react';
import { connect } from 'react-redux';
import { logout } from '../../actions/Login/action';
import LogOutPage from '../../pages/Logout/Logout.page';
import { LogIn } from '../../models/home/login.model';
import { updateGPSInformation } from "app/actions/myload/action";

class LogOutContainer extends Component<any, any> {
  _clear = new LogIn();

  logout = () => {
    this._clear.clearToken();
    this.props.logout();
  };

  render() {
    return <LogOutPage logout={this.logout} {...this.props} />;
  }
}

export const mapDispatchToProps = (dispatch: Function) => ({
  logout: () => dispatch(logout()),
  updateGPSInfo: (
    data: any,
    callback: (response: {status : string, message: string}) => void
  ) => {
    dispatch(updateGPSInformation(data, callback));
  },
});

export default connect(null, mapDispatchToProps)(LogOutContainer);

export {LogOutContainer}
